import { action, atom } from '@reatom/framework'

import { reatomCurrencyInput } from '@root/features/currency/currency-input-reatom'

import type { Atom } from '@reatom/framework'
import type { CurrencyModel } from '@root/entities/currency'
import type { WalletModel } from '@root/entities/wallet/atoms'

export const transferAmountReatom = ({
  currencyAtom,
  wallet,
}: {
  currencyAtom: Atom<CurrencyModel>
  wallet: WalletModel
}) => {
  const walletAtom = atom(wallet, 'walletAtom')
  const inputModel = reatomCurrencyInput(
    {
      currencyAtom: currencyAtom,
      walletAtom: walletAtom,
      initialRawAmount: '0',
    },
    'inputModel',
  )

  const isMaxAmountAtom = atom((ctx) => {
    const percentage = ctx.spy(inputModel.amountBalancePercentageAtom)
    return percentage >= 1
  }, 'isMaxAmountAtom')

  const setMaxAmountAction = action((ctx) => {
    inputModel.setQuickAmount(ctx, 1)
  }, 'setMaxAmountAction')

  return {
    balanceAtom: inputModel.balanceAtom,
    amountRawAtom: inputModel.amountRawAtom,
    amountAtom: inputModel.amountAtom,
    amountUsdStateAtom: inputModel.amountUsdStateAtom,
    currencyPriceUsdStateAtom: inputModel.currencyPriceUsdStateAtom,
    isMaxAmountAtom,
    setAmountAction: inputModel.setAmountRawAction,
    setMaxAmountAction,
  }
}
export type TransferAmountReatom = ReturnType<typeof transferAmountReatom>
